import classNames from "classnames";
import styles from "./style.module.scss";

interface ContentBodyLoaderProps {
  center?: boolean;
  size?: number;
}

export default function ContentBodyLoader({
  center = false,
  size,
}: ContentBodyLoaderProps) {
  return (
    <div
      style={size ? { height: size, width: size } : {}}
      className={classNames(styles.contentBodyLoader, {
        [styles.center]: center,
      })}
    ></div>
  );
}
